import React from "react";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect } from "react-router-dom";

import "assets/scss/material-kit-react.scss?v=1.8.0";

// pages for this product
import Components from "views/Components/Components.js";
import LandingPage from "views/LandingPage/LandingPage.js";
import ProfilePage from "views/ProfilePage/ProfilePage.js";
import LoginPage from "views/LoginPage/LoginPage.js";

import MainPage from "views/MainPage/MainPage.js";
import CalendarPage from "views/MainPage/CalendarPage.js";

/*
      <Route path="/landing-page" component={LandingPage} />
      <Route path="/profile-page" component={ProfilePage} />
      <Route path="/login-page" component={LoginPage} />
      <Route path="/components" component={Components} />
*/
var hist = createBrowserHistory();

ReactDOM.render(
  <Router history={hist}>
    <Switch>
      <Route path="/main" component={MainPage} />
      <Route path="/cal/:roomname" render={(props) => <CalendarPage {...props} set={false}/>}/>
      <Redirect from="/" to="/main" />
    </Switch>
  </Router>,
  document.getElementById("root")
);
